import { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PeopleChartEmployeeSidepanelBasicInfoFragment } from 'generated/resources/graphql'

type Props = {
  employee: PeopleChartEmployeeSidepanelBasicInfoFragment
}

const TeamsDetail: FC<Props> = ({ employee }) => {
  return (
    <Box
      background="grey100"
      borderRadius={{
        topLeft: 'abs016',
        topRight: 'abs016',
      }}
    >
      <Box padding="s32">
        <Box
          border={{
            bottom: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          gap="s16"
          paddingBottom="s16"
        >
          <Text.Normal weight="bold" size="300">
            General Information
          </Text.Normal>
          <Box justifyContent="spaceBetween" flexDirection="row" gap="s8">
            <Box gap="s12">
              <Text.Normal weight="medium" size="100">
                Manager
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                Legal Entity
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                Hiring Date
              </Text.Normal>
            </Box>
            <Box alignItems="flexEnd" gap="s12">
              <Text.Normal size="100" weight="semibold">
                {employee.manager?.fullName}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.legalEntity?.legalName}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.referenceContract?.startsOn}
              </Text.Normal>
            </Box>
          </Box>
        </Box>

        <Box
          border={{
            bottom: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          paddingBottom="s16"
          paddingTop="s16"
          gap="s16"
        >
          <Text.Normal weight="bold">Contact Details</Text.Normal>
          <Box justifyContent="spaceBetween" flexDirection="row">
            <Box gap="s12">
              <Text.Normal weight="medium" size="100">
                Email
              </Text.Normal>
              <Text.Normal weight="medium" size="100">
                Phone
              </Text.Normal>
            </Box>
            <Box alignItems="flexEnd" gap="s12">
              <Text.Normal size="100" weight="semibold">
                {employee.email}
              </Text.Normal>
              <Text.Normal size="100" weight="semibold">
                {employee.phoneNumber}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default TeamsDetail
